import React, { useCallback } from 'react';
import { Divider, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import CloseButton from '../Buttons/CloseButton';

type Props = {
  text: string;
  onClose?: () => void;
  hideCloseButton?: boolean;
  showDivider?: boolean;
  endAdornment?: JSX.Element;
  className?: string;
};

const BaseModalTitle: React.FC<Props> = ({
  text = '',
  onClose,
  hideCloseButton,
  endAdornment,
  className,
  showDivider = true,
}) => {
  const [, { closeModal }] = useModal();
  const classes = useStyles();

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
    closeModal();
  }, [onClose, closeModal]);

  return (
    <>
      <MuiDialogTitle
        className={`${classes.titleClass} ${classes.baseTitleClass} ${className ?? ''}`}
      >
        <Typography variant="h2">{text}</Typography>
        {!hideCloseButton && (
          <div className={classes.rightButtons}>
            {showDivider && <Divider orientation="vertical" />}
            <CloseButton onClick={handleClose} color={'white'} margin={'unset'} />
          </div>
        )}
        {endAdornment}
      </MuiDialogTitle>
    </>
  );
};

const useStyles = makeStyles((theme: any) => ({
  baseTitleClass: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 24px',
    fontSize: '1.625rem',
    height: '60px',
    fontWeight: 'normal',
  },
  rightButtons: {
    height: '100%',
    width: '60px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: `-${theme.spacing(6)}`,
  },
  titleClass: () => ({
    backgroundColor: theme.palette.secondary.dark,
    color: 'white',
  }),
}));

export default BaseModalTitle;
